import React from "react";
import { Text } from "@origin-digital/style-guide";
import styled from "styled-components";
var StyledList = styled.ul.withConfig({
  displayName: "BulletedList__StyledList",
  componentId: "ob165v-0"
})(["padding-left:20px;margin-bottom:0;li{line-height:24px;padding:8px;}"]);
export var BulletedList = function BulletedList(_ref) {
  var content = _ref.content;
  return React.createElement(React.Fragment, null, React.createElement(Text, {
    size: "sm",
    fontWeight: content.subHeadingWeight
  }, content.subHeading), React.createElement(StyledList, null, content.item1 && React.createElement("li", null, content.item1), content.item2 && React.createElement("li", null, content.item2), content.item3 && React.createElement("li", null, content.item3)));
};